import { HTMLAttributes, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface FormItemNameProps extends HTMLAttributes<HTMLLabelElement> {
  name?: ReactNode;
  isRequired?: boolean;
  htmlFor?: string;
}

export const FormItemName = ({ name, isRequired, htmlFor, className, ...props }: FormItemNameProps) => (
  <label
    className={twMerge('font-manrope text-xs font-medium uppercase text-[#240089]', className)}
    htmlFor={htmlFor}
    {...props}
  >
    {name}
    {isRequired && <span className="ml-1 text-[#FF0083]">*</span>}
  </label>
);
